import WidgetHowManyWeAre from "./widget-how-many-we-are";

export default WidgetHowManyWeAre;